import { AUTH, ENCRYPTREG } from '~~/config'
import { sha256 } from 'js-sha256'
import { Method } from '~~/enum'

export interface ISignParams {
  path: string
  method: string
  params?: IObject
  body?: IObject | string | null
  appkey?: string
  secretkey?: string
}

export interface IHeaderSign extends IObject {
  'bt-auth-sign'?: string
  'bt-auth-appkey'?: string
  'bt-auth-nonce'?: string
  'bt-auth-timestamp'?: number
}

export class Encrypt {
  path: string
  method: string
  type: string
  params?: IObject
  body?: IObject | string | null
  appkey?: string
  secretkey?: string

  constructor(ctx: ISignParams) {
    this.path = ctx.path
    this.method = ctx.method.toUpperCase()
    this.type = this.method === Method.POST ? 'application/json' : ''
    this.params = ctx.params
    this.body = ctx.body
    this.appkey = ctx.appkey || AUTH.APP_KEY
    this.secretkey = ctx.secretkey || AUTH.SECRET_KEY
  }

  public getHearderSign() {
    const headerSign: IHeaderSign = {
      'bt-auth-appkey': this.appkey,
      'bt-auth-nonce': this._randomCoding(),
      'bt-auth-timestamp': new Date().getTime(),
    }
    let headString = ''
    for (const i in headerSign) {
      headString = `${headString}${i}:${headerSign[i]}`
    }
    headerSign['bt-auth-sign'] = this._getSign(headString)
    return headerSign
  }

  /**
   * 获取 bt-auth-sign
   * @param heardSting
   * @returns
   */
  private _getSign(headString: string) {
    const paramsSting = this._sortArry()
    const path = this.path.replace(ENCRYPTREG, '')
    const stringSign = `${this.method}${path}${headString}${paramsSting}${this.secretkey}`
    // console.log('ctx__________', stringSign)
    let stringDet = encodeURIComponent(stringSign)
    stringDet = stringDet
      .replace(/\(/g, '%28')
      .replace(/\)/g, '%29')
      .replace(/'/g, '%27')
      .replace(/!/g, '%21')
      .replace(/~/g, '%7E')
    return sha256(stringDet)
  }

  /**
   * 排序
   */
  private _sortArry() {
    const paramsArry = []
    let paramsSting = ''
    this.params &&
      Object.entries(this.params).forEach((item) => {
        if (item[1]) {
          paramsArry.push({
            name: decodeURIComponent(item[0].toLowerCase()),
            value: decodeURIComponent(item[1].toString().replace(/\s*/g, '')),
          })
        }
      })
    if (this.method === Method.POST && this.type.includes('application/json')) {
      paramsArry.push({
        name: 'json',
        value: this.body ? JSON.stringify(this.body).replace(/\s*/g, '') : {},
      })
    }
    paramsArry.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
    paramsArry.forEach((item) => {
      paramsSting = paramsSting + item.name + '=' + item.value
    })
    return paramsSting
  }

  /**
   * 获取 bt-auth-nonce
   * @returns
   */
  private _randomCoding() {
    let string = ''
    for (let i = string.length; i < 17; i++) {
      string = string + Math.random().toString(36).substr(2)
    }
    return string.substr(0, 16)
  }
}
